import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { BONO1_URL, BONO2_URL, BONO3_URL, BONO4_URL, BONO5_URL, BONO6_URL } from './constants';
const bonos = [{
  n: 'Bono 1',
  title: 'Mapa de Implementación 7 Días',
  desc: 'Resultados desde el día 1 · Sin abrumarte.',
  price: '$25 USD',
  img: BONO1_URL
}, {
  n: 'Bono 2',
  title: '30 Dinámicas de Emergencia',
  desc: 'Clase funcionando en 5 minutos · Sin preparación.',
  price: '$20 USD',
  img: BONO2_URL
}, {
  n: 'Bono 3',
  title: 'Kit de Inicio de Año Escolar',
  desc: '2 semanas listas antes del primer lunes.',
  price: '$22 USD',
  img: BONO3_URL
}, {
  n: 'Bono 4',
  title: '50 Frases Motivadoras para el Aula',
  desc: 'Palabras exactas · Para cada situación difícil.',
  price: '$15 USD',
  img: BONO4_URL
}, {
  n: 'Bono 5',
  title: 'Guía de Familias Aliadas',
  desc: 'Responde en 3 minutos · 0 mensajes el domingo.',
  price: '$18 USD',
  img: BONO5_URL
}, {
  n: 'Bono 6',
  title: 'Plan Anti-Atraso Escolar',
  desc: 'Recupera una semana perdida en 15 minutos.',
  price: '$20 USD',
  img: BONO6_URL
}];
export function Bonos() {
  return <section className="bg-cream px-4 py-16" data-id="element-17">
      <div className="mx-auto max-w-4xl text-center" data-id="element-18">
        <span className="inline-flex items-center gap-2 rounded-full bg-brandpurple/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-brandpurple" data-id="element-19">
          <GiftIcon className="h-4 w-4" data-id="element-20" /> 6 Bonos estratégicos
        </span>
        <h2 className="mt-4 font-display text-3xl font-black text-navy sm:text-4xl" data-id="element-21">
          Todo lo que sumas gratis hoy
        </h2>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 sm:grid-cols-2" data-id="element-22">
        {bonos.map((b, i) => <motion.div key={b.n} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.06
      }} className="flex items-center gap-4 rounded-2xl border border-navy/10 bg-white p-4 shadow-card" data-id="element-23">
            <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-cream" data-id="element-24">
              <img src={b.img} alt={b.title} className="h-full w-full object-cover" data-id="element-25" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-26">
              <div className="text-[11px] font-bold uppercase tracking-wide text-brandpurple" data-id="element-27">
                {b.n}
              </div>
              <h3 className="font-display text-[15px] font-black leading-tight text-navy" data-id="element-28">
                {b.title}
              </h3>
              <p className="mt-0.5 text-xs text-navy/60" data-id="element-29">{b.desc}</p>
              <div className="mt-1.5 flex items-center gap-2" data-id="element-30">
                <span className="text-xs font-semibold text-navy/40 line-through" data-id="element-31">
                  {b.price}
                </span>
                <span className="rounded-full bg-teal/15 px-2 py-0.5 text-[11px] font-bold uppercase text-teal" data-id="element-32">
                  Gratis
                </span>
              </div>
            </div>
          </motion.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-md rounded-2xl bg-navy p-6 text-center text-white shadow-soft" data-id="element-33">
        <p className="text-xs font-bold uppercase tracking-widest text-white/60" data-id="element-34">
          Valor total de bonos
        </p>
        <p className="mt-1 font-display text-4xl font-black" data-id="element-35">$120 USD</p>
        <p className="mt-2 text-sm font-semibold text-teal" data-id="element-36">
          → GRATIS con tu Método Domingo Libre
        </p>
      </div>
    </section>;
}